import styled from "styled-components";

export const Tooltip = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 100%);
  background-color: #595959;
  border-radius: 3px;
  text-align: center;
  padding: 4px 20px;
  min-width: 120px;
  max-width: 180px;
  color: #ffffff;
  font-size: 11px;
  letter-spacing: 0.4px;
  font-weight: 400;
  opacity: 0;
  pointer-events: none;
  z-index: 99;
  white-space: nowrap;
`;

export const TypographyRange = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
  border-radius: 3px;
  transition: background-color 0.2s;
  padding: 12px 10px 10px 10px;

  &:hover {
    background-color: #E5F3FD;

    ${Tooltip} {
      opacity: 1;
      transition: 0.2s opacity 0.3s cubic-bezier(0.55, 0.3, 0.5, 0.9);
    }
  }
`;

export const RangeInputContainer = styled.div`
  width: 70%;
`;

export const WrapperIconTypography = styled.div`
  margin-right: 10px;

  > img {
    width: 18px;
  }
`;

export const InputItemTypography = styled.input`
  border: 1px solid transparent;
  background-color: transparent;
  width: 35px;
  text-align: right;
  margin-left: 10px;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:focus,
  &:hover {
    outline: none;
    border: 1px solid #ebebeb;
    background-color: #ffffff;
    border-radius: 2px;
  }

  &:focus {
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
  }

  ${(props) => props.inputError && "border-color: #E83535;"}
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 285px;
  padding: 18px;
`;

export const InputSelect = styled.select`
  width: 100%;
  padding: 5px 12px;
  text-align: center;
  font-size: 12px;
  border-color: #ebebeb;
  text-align: left;
  margin-bottom: 10px;
  margin-top: 10px;
  border-radius: 3px;

  &:focus {
    outline: none;
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
  }
`;

export const TransformOption = styled.div`
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  border-color: #C9C9C9; 
  background-color: white;
  border-color: ${(props) => (props.active ? "#44ADF8" : "#C9C9C9")};
  padding: 6px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${(props) => {
    return props.active && "outline: 2px solid #44ADF8; outline-offset: -2px;"
  }}

  &:first-child {
    border-radius: 2px 0 0 2px;
  }

  &:last-child {
    border-radius: 0 2px 2px 0;
    border-width: 1px;
  }
`;

export const TypographyItems = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin-bottom: 10px;
  justify-content: flex-end;
`;

export const LabelTypography = styled.p`
  text-align: end;
  margin-right: 8px;
`;

export const PickerAndTransform = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
`;
